<template>
    <u-tab-punch v-bind="$attrs">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-tab-punch>
</template>

<script>
import UTabPunch from "@/components/publish/styles/tabs/u-tab-punch.vue";

export default {
    props: {},
    components: {
        UTabPunch,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
